import React, { Component } from 'react';


import Highcharts from 'highcharts/highstock';
import drilldown from 'highcharts-drilldown';
import HighchartsReact from 'highcharts-react-official';

// drilldown(Highcharts);
export default class PieChartComponent extends Component {

    constructor(props) {
        super(props);
    }

    render(){
    	
        const dStyles={
				width:'100%',
				height:'100%',
                fontWeight: "bold"
		}
		const highchartoptions = {
	      		 
			chart: {
                plotBackgroundColor: null,
                plotBorderWidth: null,
                plotShadow: false,
                type: 'pie',
                // height:"500px"
            },
            title: {
                text: this.props.title,
                align: 'left'
            },
          
            tooltip: {
                pointFormat: '{series.name}: {point.y} (<b>{point.percentage:.1f}%</b>)'
            },
            accessibility: {
                point: {
                    valueSuffix: '%'
                }
            },
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    // dataLabels: {
                    //     enabled: true
                    // },
                    showInLegend: true
                },
                series: {
                    borderRadius: 5,
                    dataLabels: {
                        enabled: true,
                        format: '{point.y} (<b>{point.percentage:.1f}%</b>)'
                    }
                }
            },
            series: this.props.series,
            credits:false
            // series:[
            //     {
            //         "name": "Planning",
            //         "colorByPoint": true,
            //         "data": [
            //             {
            //                 "name": "Total Demand CMT",
            //                 "y": 101
            //             },
            //             {
            //                 "name": "Planned Demand CMT",
            //                 "y": 10
            //             },
            //             {
            //                 "name": "Dropped Demand CMT",
            //                 "y": 20
            //             },
            //             {
            //                 "name": "Unplanned Demand CMT",
            //                 "y": 30
            //             }
            //         ]
            //     }
            // ],
			};

        return ( 
               <HighchartsReact containerProps={{ style: { width: '100%', height: '100%', fontSize: "30px", fontWeight: "bold" } }} highcharts={Highcharts} style={dStyles} options={highchartoptions} />

			);
		}
}
